var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 150 792 300",
    style: {
      enableBackground: "new 0 0 792 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#505255;}\n\t.st2{fill:#DC9A64;}\n\t.st3{fill:#C15E28;}\n\t.st4{fill:#94C03D;}\n\t.st5{fill:#60823A;}\n\t.st6{fill:#AD4925;}\n\t.st7{fill:none;}\n\t.st8{fill:#505256;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.98,324.69v1.45h-14.96l-5.79-19.54h-30.28l-6.03,19.54h-14.6v-1.45l25.58-77.33 c6.88-0.24,13.63-0.36,19.91-0.36l0.72,0.36L153.98,324.69z M130.09,296.09l-10.98-36.92h-1.69l-11.22,36.8L130.09,296.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.73,325.65V260.5c0-4.46,0-8.93-0.24-13.39h13.63l0.84,0.36v67.56l30.76-0.36l0.84,0.48 c0.12,3.62-0.24,7.84-0.97,10.98h-44.16L160.73,325.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.76,325.65l2.05-78.3c6.15-0.24,12.67-0.36,18.82-0.36l0.72,0.48l22.8,61.65H257l21.47-61.77 c6.03-0.24,12.18-0.36,18.46-0.36l0.72,0.48l2.05,63.58c0.12,5.31,0.36,10.5,0.6,15.08h-13.63l-0.72-0.48l-0.72-60.68h-0.96 l-20.87,58.27c-4.58,0.24-9.65,0.48-14.24,0.48l-0.72-0.48l-21.23-58.27H226l-0.24,46.09c-0.12,4.71-0.24,10.13-0.24,15.08 h-13.03L211.76,325.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.24,286.8c0-27.75,15.08-40.9,36.68-40.9c22.2,0,35.59,13.75,35.59,40.29 c0,27.14-13.63,41.14-36.31,41.14C323.23,327.34,309.24,314.79,309.24,286.8z M366.9,286.56c0-19.67-6.88-29.8-20.87-29.8 c-13.51,0-22.2,10.38-22.2,29.8c0,19.54,7.48,29.92,21.47,29.92C359.78,316.48,366.9,306.23,366.9,286.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.46,325.89l-35.47-57.06h-0.84l0.36,43.43c0.12,4.58,0.12,9.29,0.24,13.87h-13.27l-0.72-0.48v-65.27 c0-4.46,0-8.69-0.24-13.15c5.07-0.12,9.89-0.24,14.72-0.24l0.72,0.48l35.35,56.7h0.84l-0.12-43.67c0-4.46-0.12-8.93-0.24-13.39 h13.03l0.72,0.48l0.12,64.79c0,4.83,0.12,9.29,0.24,13.75c-4.71,0.12-9.77,0.24-14.72,0.24L441.46,325.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.65,325.89l-0.72-0.48v-64.54c0-4.46,0-9.29-0.24-13.75h25.94c27.02,0,41.26,12.67,41.26,38.73 c0,26.78-16.29,40.29-41.98,40.29C488.14,326.13,478.49,326.13,470.65,325.89z M522.28,286.32c0-18.94-7.84-28.71-28.11-28.71 c-2.9,0-6.76,0-10.01,0.12v57.79c2.9,0.12,6.76,0.12,9.65,0.12C513.24,315.64,522.28,305.5,522.28,286.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Logo_00000142166031765527990620000001533903888078163335_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M616.85,315.84c18.81-14.59,44.95-52.75,33.94-66.14c-11.01-13.39-55.04,3.21-73.76,17.8 c-18.71,14.59-25.04,37.34-14.04,50.64C574,331.52,598.13,330.52,616.85,315.84z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M618.5,208.05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5304 -0.8478 0.8478 0.5304 30.0625 625.6934)",
    className: "st3",
    cx: 579.78,
    cy: 285.71,
    rx: 7.25,
    ry: 5.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.53 -0.848 0.848 0.53 43.7893 667.3807)",
    className: "st3",
    cx: 623.95,
    cy: 294.19,
    rx: 6.05,
    ry: 4.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6258 -0.78 0.78 0.6258 19.3643 590.2008)",
    className: "st3",
    cx: 624.78,
    cy: 274.92,
    rx: 6.88,
    ry: 5.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4433 -0.8964 0.8964 0.4433 123.2114 713.2123)",
    className: "st3",
    cx: 635.79,
    cy: 257.41,
    rx: 4.59,
    ry: 3.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5747 -0.8184 0.8184 0.5747 33.2758 605.069)",
    className: "st3",
    cx: 598.76,
    cy: 270.52,
    rx: 4.13,
    ry: 3.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7016 -0.7126 0.7126 0.7016 -47.0652 505.7675)",
    className: "st3",
    cx: 580.33,
    cy: 309.08,
    rx: 4.31,
    ry: 2.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7399 -0.6727 0.6727 0.7399 -51.8567 486.1565)",
    className: "st3",
    cx: 602.78,
    cy: 310.14,
    rx: 4.13,
    ry: 3.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7087 -0.7056 0.7056 0.7087 -31.9561 507.9474)",
    className: "st3",
    cx: 599.07,
    cy: 292.67,
    rx: 4.95,
    ry: 3.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6111 -0.7915 0.7915 0.6111 32.6253 587.3105)",
    className: "st3",
    cx: 614.03,
    cy: 260.45,
    rx: 4.86,
    ry: 2.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.55,266.12c-2.11,7.25-6.42,15.87-12.66,24.86c-7.25,10.64-16.24,20.55-24.13,26.7 c-2.2,1.65-4.4,3.21-6.79,4.59c7.61,4.13,17.06,6.51,27.25,6.51c24.86,0,71.46-14.4,71.46-32.11 C709.78,282.35,679.32,270.24,654.55,266.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M637.76,242.54c1.56,0,3.03,0.09,4.4,0.28c-5.14-16.05-12.29-31.1-14.49-31.28 c-3.12-0.28-16.51,20.82-24.13,39.26C615.38,245.93,627.95,242.54,637.76,242.54z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M626.66,243.64l1.74-31.28c0-0.46-0.37-0.83-0.83-0.92c-0.46,0-0.83,0.37-0.92,0.83l-1.83,31.74 C625.56,243.82,626.11,243.73,626.66,243.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M575.47,266.21c8.9-6.97,23.48-14.4,37.7-18.99c-13.49-15.05-33.58-30.82-36.14-29.81 c-3.03,1.28-4.86,28.99-2.11,49.26C575.1,266.48,575.29,266.3,575.47,266.21z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M594.09,254.83c0.46-0.28,1.01-0.46,1.47-0.73l-17.8-36.33c-0.18-0.46-0.73-0.55-1.1-0.37 c-0.46,0.18-0.55,0.73-0.37,1.1L594.09,254.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M688.31,304.19c-0.28-0.37-0.73-0.46-1.19-0.28c-13.85,9.27-38.53,14.22-52.84,13.12 c-4.4-0.37-8.62-1.28-12.57-2.75c-0.46,0.46-0.92,0.83-1.38,1.19c4.31,1.74,8.99,2.84,13.85,3.21c1.38,0.09,2.84,0.18,4.4,0.18 c14.77,0,36.33-4.77,49.54-13.58C688.4,305.1,688.49,304.55,688.31,304.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M688.03,287.58c-9.82-6.51-24.13-10.83-36.88-12.66c-0.28,0.55-0.46,1.1-0.73,1.65 c12.84,1.74,27.34,6.15,36.79,12.38c0.18,0.09,0.28,0.18,0.46,0.18c0.28,0,0.55-0.09,0.73-0.37 C688.49,288.41,688.4,287.86,688.03,287.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M673.81,295.84h-35.5c-0.46,0.55-0.83,1.1-1.28,1.65h36.79c0.46,0,0.83-0.37,0.83-0.83 C674.64,296.21,674.27,295.84,673.81,295.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M647.67,272.63c1.47-18.07-16.24-60.91-20-61.19c-4.22-0.28-27.89,39.45-29.36,57.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M624.09,262.45c-7.43-16.7-43.58-46.51-46.97-45.04c-3.94,1.65-5.87,47.52,1.56,64.22"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M364.26,375.3v-26.65c0-1.61,0-3.56-0.1-5.17h18.79l0.2,0.15c-0.05,0.88-0.24,1.71-0.44,2.44l-15.38-0.1 v12.84h13.03l0.29,0.15c0.2,0.73,0.34,1.66,0.39,2.49l-13.72-0.19v9.42c0,1.61,0,3.17,0.05,4.78h-2.93L364.26,375.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M389.45,375.3v-27.04c0-1.61,0-3.17-0.1-4.78h2.98l0.19,0.15v27.04c0,1.61,0,3.17,0.05,4.78h-2.93 L389.45,375.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M421.42,375.4l-17.23-27.73h-0.24v22.45c0.05,1.76,0.05,3.51,0.1,5.32h-2.88l-0.2-0.15v-27.04 c0-1.61,0-3.08-0.1-4.69c1.32-0.05,2.59-0.1,3.86-0.1l0.19,0.15l17.23,27.68h0.24v-23.04c0-1.61,0-3.17-0.05-4.78h2.83l0.19,0.15 l0.05,26.65c0,1.95,0,3.56,0.05,5.17c-1.17,0.05-2.64,0.1-3.86,0.1L421.42,375.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M439.33,375.35l0.05-29.29h-10.69l-0.19-0.1c0-0.83,0-1.66,0.05-2.49h24.5l0.2,0.1 c0,0.83-0.05,1.71-0.1,2.49H442.4v24.7c0,1.56,0,3.13,0.1,4.69h-2.93L439.33,375.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456.26,375.35v-26.7c0-1.66,0-3.56-0.1-5.17h18.79l0.25,0.1c-0.05,0.88-0.25,1.76-0.49,2.49l-15.38-0.1 v12.35l13.37-0.05l0.25,0.15c0.19,0.78,0.34,1.66,0.44,2.49l-14.06-0.19v12.25l15.62-0.15l0.2,0.15 c-0.05,0.83-0.2,1.76-0.39,2.49h-18.3L456.26,375.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M479.05,359.58c0-11.32,7.03-16.6,15.57-16.6c2.93,0,5.32,0.44,7.13,1.17c0.2,0.83,0.29,1.95,0.29,2.78 l-0.19,0.15c-2.2-1.03-4.49-1.46-6.78-1.46c-7.52,0-12.84,4.93-12.84,13.96c0,9.57,4.93,13.72,12.89,13.72 c2.15,0,5.13-0.49,7.18-1.46l0.19,0.15c0,0.83-0.19,2.05-0.39,2.78c-1.81,0.78-4.44,1.17-7.47,1.17 C485.69,375.93,479.05,371.44,479.05,359.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M507.61,375.3v-27.04c0-1.61,0-3.17-0.1-4.78h2.98l0.19,0.15v14.3h16.94v-9.67c0-1.61,0-3.17-0.05-4.78h2.93 l0.19,0.15v27.04c0,1.61,0,3.17,0.05,4.78h-2.93l-0.19-0.15v-14.89h-16.94v10.25c0,1.61,0,3.17,0.05,4.78h-2.93L507.61,375.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.ff5e70970026c6ace9586c2f238604ce.svg";
export { ForwardRef as ReactComponent };